<template>
    <footer class="footer has-cards">
        <!-- <div class="container container-lg">
            <div class="row">
                <div class="col-md-6 mb-5 mb-md-0">
                    <div class="card card-lift--hover shadow border-0">
                        <router-link to="/landing" title="Landing Page">
                            <img v-lazy="'img/theme/landing.jpg'" class="card-img">
                        </router-link>
                    </div>
                </div>
                <div class="col-md-6 mb-5 mb-lg-0">
                    <div class="card card-lift--hover shadow border-0">
                        <router-link to="/profile" title="Profile Page">
                            <img v-lazy="'img/theme/profile.jpg'" class="card-img">
                        </router-link>
                    </div>
                </div>
            </div>
        </div> -->
        <div class="container container-lg">
        <div class="row justify-content-center">

                        <div class="col-md-6 mb-5 mb-lg-0">
                            <card gradient="secondary" shadow body-classes="p-lg-5">
                                <h4 class="mb-1">Envie de faire partie de l'association?</h4>
                                <p class="mt-0">Contactez-nous par téléphone ou e-mail.</p>
                                <!-- <a href="mailto:dambeninieta@gmail.com?subject=Bonjour de dambeninieta.com&body=Prénom et Nom:%0D%0A%0D%0A%0D%0AMerci!">
                                    <base-button class="btn-1" type="warning">Cliquez ici pour nous contacter!</base-button>
                                </a> -->
                                <card shadow class="shadow-lg--hover mt-5">
                                    <div class="d-flex px-3">
                                        <div class="title text-black">
                                            <icon name="" gradient="warning" color="white" shadow
                                                rounded><i class="fa fa-phone"></i></icon>
                                        </div>
                                        <div class="pl-4">
                                            <h5 class="title text-warning">Téléphone</h5>
                                            <h6>64 55 70 19</h6>
                                            <!-- <a href="#" class="text-warning">Learn more</a> -->
                                        </div>
                                    </div>
                                </card>
                                
                                <card shadow class="shadow-lg--hover mt-5">
                                    <div class="d-flex px-3">
                                        <div class="title text-black">
                                            <icon name="ni ni-email-83" gradient="success" color="white" shadow
                                                rounded></icon>
                                        </div>
                                        <div class="pl-4">
                                            <h5 class="title text-success">E-mail</h5>
                                            <h6>dambeninieta@gmail.com</h6>
                                            <!-- <a href="#" class="text-warning">Learn more</a> -->
                                        </div>
                                    </div>
                                </card>
                            </card>
                        </div>

        </div>
        </div>

        <div class="container">
            <div class="row row-grid align-items-center my-md">
                <div class="col-lg-6">
                    <h3 class="text-primary font-weight-light mb-2">Merci de nous avoir visité</h3>
                    <h4 class="mb-0 font-weight-light">Ajoutez-nous sur ces plateformes</h4>
                </div>
                <div class="col-lg-6 text-lg-center btn-wrapper">
                    <a target="_blank" rel="noopener" href="https://www.facebook.com/Dambé-ni-Nieta-100953504613504/"
                       class="btn btn-neutral btn-icon-only btn-facebook btn-round btn-lg" data-toggle="tooltip"
                       data-original-title="Like us">
                        <i class="fa fa-facebook-square"></i>
                    </a>
                    <a target="_blank" rel="noopener" href="https://www.instagram.com/dambeninieta/"
                       class="btn btn-neutral btn-icon-only btn-instagram btn-round btn-lg" data-toggle="tooltip"
                       data-original-title="Like us">
                        <i class="fa fa-instagram"></i>
                    </a>
                    <a target="_blank" rel="noopener" href="https://twitter.com/dambeninieta"
                       class="btn btn-neutral btn-icon-only btn-twitter btn-round btn-lg" data-toggle="tooltip"
                       data-original-title="Follow us">
                        <i class="fa fa-twitter"></i>
                    </a>
                    <!-- <a target="_blank" rel="noopener" href="#"
                       class="btn btn-neutral btn-icon-only btn-dribbble btn-lg btn-round" data-toggle="tooltip"
                       data-original-title="Follow us">
                        <i class="fa fa-dribbble"></i>
                    </a> -->
                    <!-- <a target="_blank" rel="noopener" href="#"
                       class="btn btn-neutral btn-icon-only btn-github btn-round btn-lg" data-toggle="tooltip"
                       data-original-title="Star on Github">
                        <i class="fa fa-github"></i>
                    </a> -->
                </div>
            </div>
            <hr>
            <div class="row align-items-center justify-content-md-between">
                <div class="col-md-6">
                    <div class="copyright">
                        &copy; {{year}}
                        <a href="/" rel="noopener">Dambé ni Niéta</a>
                    </div>
                </div>
                <div class="col-md-6">
                    <ul class="nav nav-footer justify-content-end">
                        <!-- <li class="nav-item">
                            <a href="#" class="nav-link" target="_blank" rel="noopener">Creative Tim</a>
                        </li> -->
                        <li class="nav-item">
                            <a href="/" class="nav-link" rel="noopener">À propos</a>
                        </li>
                        <!-- <li class="nav-item">
                            <a href="#" class="nav-link" target="_blank" rel="noopener">Blog</a>
                        </li> -->
                        <!-- <li class="nav-item">
                            <a href="#"
                               class="nav-link" target="_blank" rel="noopener">MIT License</a>
                        </li> -->
                    </ul>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
export default {
  name: 'app-footer',
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
};
</script>
<style>
</style>
